import { render, staticRenderFns } from "./group-item-page.vue?vue&type=template&id=09fb96df&"
import script from "./group-item-page.vue?vue&type=script&lang=js&"
export * from "./group-item-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports